import { DataPage } from "types/dataResponse";

type Props = {
    page: DataPage;
    onPageChange: Function;
}

const Pagination = ({ page, onPageChange }: Props) => {
    return (
        <nav style={{marginTop: "15px"}}>
            <ul className="pagination">
                <li className={`page-item ${page.first ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(page.number - 1)}>Anterior</button>
                </li>
                <li className="page-item disabled">
                    <span className="page-link">{page.number + 1}</span>
                </li>
                <li className={`page-item ${page.last ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => onPageChange(page.number + 1)}>Próxima</button>
                </li>
            </ul>
        </nav>
    )
};

export default Pagination;